<template>
    <div style="max-width: 770px;">
        <Steps steps="4" current="2" links="true" />
        
        <form @submit.prevent="validateBeforeSubmit">
            <div class="txt-grey">Step 2</div>
            <h3 class="uc">Personal Information</h3>
            <p class="light mb-4">Let us get to know you with a few basic details.</p>
            <fieldset class="mb-3">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <BasicInput
                            label="What's your first name?"
                            id="firstName"
                            name="firstName"
                            v-model="firstName"
                            v-validate="'required'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('firstName')" 
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <BasicInput
                            label="What's your last name?"
                            id="lastName"
                            name="lastName"
                            v-model="lastName"
                            v-validate="'required'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('lastName')" 
                        />
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <CleaveInput
                            label="What's your phone number?"
                            id="phone"
                            name="phone"
                            type="tel"
                            maxlength="12"
                            help="Format: 999-999-9999"
                            :cleaveoptions="masks.phone"
                            v-model="phone"
                            v-validate="{ required: true, validateAreaCode: true, regex: /^[0-9]{3}\-[0-9]{3}\-[0-9]{4}$/ }"
                            :exval="validationAttempt"
                            :error="errors.first('phone')"
                        />
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-6 col-xl-4">
                        <CleaveInput
                            label="When is your date of birth?"
                            id="dob"
                            name="dob"
                            type="tel"
                            :cleaveoptions="masks.date"
                            help="Format: mm/dd/yyyy"
                            v-model="dob"
                            maxlength="10"
                            v-validate="'required|date_format:MM/dd/yyyy|validateAge'"
                            :exval="validationAttempt"
                            
                            :error="errors.first('dob')"
                        />
                        <input name="age_target" ref="ageTarget" type="hidden" :value="birthdate">
                    </div>
                </div>
            </fieldset>

            <fieldset class="mb-3" v-if="this.formData.loan_amount_raw > 1000">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="Estimated Credit Score"
                            id="creditScore"
                            name="creditScore"
                            v-model="creditScore"
                            v-validate="'required'"
                            :options="[{value: 'excellent', label: '720+'}, {value: 'good', label: '660-719'}, {value: 'fair', label: '600-659'}, {value: 'poor', label: '599 or less'}]"
                            errormsg="This is a required field"
                            :error="errors.first('creditScore')" 
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="What’s the purpose of your loan?"
                            id="loanPurpose"
                            name="loanPurpose"
                            v-model="loanPurpose"
                            v-validate="'required'"
                            :options="[{value: 'debt consolidation', label: 'Debt Consolidation'}, {value: 'medical', label: 'Medical'}, {value: 'home improvement', label: 'Home Improvement'}, {value: 'credit card consolidation', label: 'Credit Card Consolidation'}, {value: 'auto purchase', label: 'Auto Purchase'}, {value: 'major', label: 'Major Purpose'}, {value: 'business', label: 'Start a Business or Business'}, {value: 'vacation', label: 'Vacation'}, {value: 'wedding', label: 'Wedding'}, {value: 'other', label: 'Other'}]"
                            errormsg="This is a required field"
                            :error="errors.first('loanPurpose')" 
                        />
                    </div>
                </div>
            </fieldset>

            <div class="my-5 d-flex align-items-center">
                <button class="btn btn-cta btn-red uc" id="form-submit">{{saving ? 'Saving...' : 'Continue'}}</button>
                <div>
                    <transition name="slide">
                        <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                    </transition>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import BasicInput from '@/components/form/BasicInput.vue';
import CleaveInput from '@/components/form/CleaveInput.vue';
import Select from '@/components/form/Select.vue';
import Steps from '@/components/form/Steps.vue';

import { mapGetters, mapActions } from "vuex";

export default {
    name: 'FormStep2',
    title: 'Register | Step 2',
    components:{
        BasicInput,
        CleaveInput,
        Select,
        Steps
    },
    data() {
	  return {
            validationAttempt: false,
            saving: false,

            firstName: '',
            lastName: '',
            phone: '',
            dob: '',
            creditScore: '',
            loanPurpose: '',


            masks: {
                date: { date: true, delimiter: '/', datePattern: ['m', 'd', 'Y'] },
                phone: { numericOnly: true, delimiter: '-', blocks: [3, 3, 4] }
            }
		}
    },
    methods: {
        ...mapActions(['saveFormData', 'registerPoint']),
        validateBeforeSubmit() {
            this.saving = true;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({
                        'firstName': this.firstName,
                        'lastName': this.lastName,
                        'phone' : this.phone,
                        'dob' : this.dob,
                        'creditScore' : this.creditScore,
                        'loanPurpose' : this.loanPurpose,
						'secondStep': true,
                    });
                    this.$router.push({ path: '/registration/3' })
                    return;
                }

                this.saving = false;
				
      		});
		},
    },
    computed: {
        ...mapGetters(["formData"]),
        birthdate() {
            const date = new Date();
            let d = date.getDate() + 1 < 10 ? `0${date.getDate()+1}` : date.getDate()+1;
            let m = date.getMonth() + 1 < 10 ? `0${date.getMonth()+1}` : date.getMonth()+1;
            return `${m}/${d}/${date.getFullYear()-18}`;
        }
    },
    created(){
        this.firstName = this.formData.firstName || '';
        this.lastName = this.formData.lastName || '';
        this.phone = this.formData.phone || '';
        this.dob = this.formData.dob || '';
        this.creditScore = this.formData.creditScore || '';
        this.loanPurpose = this.formData.loanPurpose || '';
  },
  mounted(){
        this.registerPoint('longFormStart');
  }
}
</script>